import PropTypes from "prop-types";
import ProgrammesCard from "./ProgrammesCard";

ProgrammesList.propTypes = {
  products: PropTypes.array.isRequired,
};

export default function ProgrammesList({ programmes, reload, ...other }) {
  return (
    <div className="row">
      {programmes.map((programm) => (
        <div className="col-lg-4 col-md-4 col-sm-12 mt-4">
          <ProgrammesCard programm={programm} reload={reload} />
        </div>
      ))}
    </div>
  );
}
